// extracted by mini-css-extract-plugin
export default {"shareMenu":"ShareMenu_shareMenu__XM9DI","shareMenu--top":"ShareMenu_shareMenu--top__+2Yes"};